import I18n from 'I18n';
const i18nKey = key => `contentUtils.choiceButtonPresets.${key}`;
// @ts-expect-error image
import layoutTiles from 'bender-url!ContentUtils/img/choiceButtons/layout-tiles.svg';
// @ts-expect-error image
import layoutCards from 'bender-url!ContentUtils/img/choiceButtons/layout-cards.svg';
// @ts-expect-error image
import layoutMinimal from 'bender-url!ContentUtils/img/choiceButtons/layout-minimal.svg';
// @ts-expect-error image
import iconSizeSmall from 'bender-url!ContentUtils/img/choiceButtons/icon-size-small.svg';
// @ts-expect-error image
import iconSizeMedium from 'bender-url!ContentUtils/img/choiceButtons/icon-size-medium.svg';
// @ts-expect-error image
import iconSizeLarge from 'bender-url!ContentUtils/img/choiceButtons/icon-size-large.svg';
// @ts-expect-error image
import iconBackgroundShapeNone from 'bender-url!ContentUtils/img/choiceButtons/icon-background-shape-none.svg';
// @ts-expect-error image
import iconBackgroundShapeSquare from 'bender-url!ContentUtils/img/choiceButtons/icon-background-shape-square.svg';
// @ts-expect-error image
import iconBackgroundShapeRounded from 'bender-url!ContentUtils/img/choiceButtons/icon-background-shape-rounded.svg';
// @ts-expect-error image
import iconBackgroundShapeCircle from 'bender-url!ContentUtils/img/choiceButtons/icon-background-shape-circle.svg';
// @ts-expect-error image
import socialIconSizeSmall from 'bender-url!ContentUtils/img/choiceButtons/social-icon-size-small.svg';
// @ts-expect-error image
import socialIconSizeMedium from 'bender-url!ContentUtils/img/choiceButtons/social-icon-size-medium.svg';
// @ts-expect-error image
import socialIconSizeLarge from 'bender-url!ContentUtils/img/choiceButtons/social-icon-size-large.svg';
// @ts-expect-error image
import socialIconBackgroundShapeSquare from 'bender-url!ContentUtils/img/choiceButtons/social-icon-background-shape-square.svg';
// @ts-expect-error image
import socialIconBackgroundShapeRounded from 'bender-url!ContentUtils/img/choiceButtons/social-icon-background-shape-rounded.svg';
// @ts-expect-error image
import socialIconBackgroundShapeCircle from 'bender-url!ContentUtils/img/choiceButtons/social-icon-background-shape-circle.svg';
export const getChoiceButtonPresets = () => {
  return {
    expand_icon: {
      caret: {
        label: I18n.text(i18nKey('caret.label')),
        set: 'fontawesome-5.14.0',
        icon: 'Caret Down'
      },
      plus: {
        label: I18n.text(i18nKey('plus.label')),
        set: 'fontawesome-5.14.0',
        icon: 'plus'
      }
    },
    layout: {
      tiles: {
        label: I18n.text(i18nKey('layoutTiles.label')),
        image: layoutTiles,
        image_alt: I18n.text(i18nKey('layoutTiles.imageAlt'))
      },
      minimal: {
        label: I18n.text(i18nKey('layoutMinimal.label')),
        image: layoutMinimal,
        image_alt: I18n.text(i18nKey('layoutMinimal.imageAlt'))
      },
      cards: {
        label: I18n.text(i18nKey('layoutCards.label')),
        image: layoutCards,
        image_alt: I18n.text(i18nKey('layoutCards.imageAlt'))
      }
    },
    icon_size: {
      small: {
        label: I18n.text(i18nKey('iconSizeSmall.label')),
        image: iconSizeSmall,
        image_alt: I18n.text(i18nKey('iconSizeSmall.imageAlt'))
      },
      medium: {
        label: I18n.text(i18nKey('iconSizeMedium.label')),
        image: iconSizeMedium,
        image_alt: I18n.text(i18nKey('iconSizeMedium.imageAlt'))
      },
      large: {
        label: I18n.text(i18nKey('iconSizeLarge.label')),
        image: iconSizeLarge,
        image_alt: I18n.text(i18nKey('iconSizeLarge.imageAlt'))
      }
    },
    icon_background_shape: {
      none: {
        label: I18n.text(i18nKey('iconBackgroundShapeNone.label')),
        image: iconBackgroundShapeNone,
        image_alt: I18n.text(i18nKey('iconBackgroundShapeNone.imageAlt'))
      },
      square: {
        label: I18n.text(i18nKey('iconBackgroundShapeSquare.label')),
        image: iconBackgroundShapeSquare,
        image_alt: I18n.text(i18nKey('iconBackgroundShapeSquare.imageAlt'))
      },
      rounded: {
        label: I18n.text(i18nKey('iconBackgroundShapeRounded.label')),
        image: iconBackgroundShapeRounded,
        image_alt: I18n.text(i18nKey('iconBackgroundShapeRounded.imageAlt'))
      },
      circle: {
        label: I18n.text(i18nKey('iconBackgroundShapeCircle.label')),
        image: iconBackgroundShapeCircle,
        image_alt: I18n.text(i18nKey('iconBackgroundShapeCircle.imageAlt'))
      }
    },
    social_icon_size: {
      small: {
        label: I18n.text(i18nKey('iconSizeSmall.label')),
        image: socialIconSizeSmall,
        image_alt: I18n.text(i18nKey('iconSizeSmall.imageAlt'))
      },
      medium: {
        label: I18n.text(i18nKey('iconSizeMedium.label')),
        image: socialIconSizeMedium,
        image_alt: I18n.text(i18nKey('iconSizeMedium.imageAlt'))
      },
      large: {
        label: I18n.text(i18nKey('iconSizeLarge.label')),
        image: socialIconSizeLarge,
        image_alt: I18n.text(i18nKey('iconSizeLarge.imageAlt'))
      }
    },
    social_icon_background_shape: {
      none: {
        label: I18n.text(i18nKey('iconBackgroundShapeNone.label')),
        image: iconBackgroundShapeNone,
        image_alt: I18n.text(i18nKey('iconBackgroundShapeNone.imageAlt'))
      },
      square: {
        label: I18n.text(i18nKey('iconBackgroundShapeSquare.label')),
        image: socialIconBackgroundShapeSquare,
        image_alt: I18n.text(i18nKey('iconBackgroundShapeSquare.imageAlt'))
      },
      rounded: {
        label: I18n.text(i18nKey('iconBackgroundShapeRounded.label')),
        image: socialIconBackgroundShapeRounded,
        image_alt: I18n.text(i18nKey('iconBackgroundShapeRounded.imageAlt'))
      },
      circle: {
        label: I18n.text(i18nKey('iconBackgroundShapeCircle.label')),
        image: socialIconBackgroundShapeCircle,
        image_alt: I18n.text(i18nKey('iconBackgroundShapeCircle.imageAlt'))
      }
    }
  };
};